import {Determinant} from "./determinant";

export class DocumentRequirementRegistration {
  public requirementName: string;
  public registrationName: string;
  public registrationShortName: string;
  public toUpload: boolean;
  public toShow: boolean;
  public toSign: boolean;
  public toPrintUpload: boolean;
  public physicalResult: boolean;
  public dematerializedResult: boolean;
  public registrationId: string;
  public requirementId: string;
  public determinants: Determinant[];
}
